(function($) {


    $(".sidebar-nav-toggle").on("mousedown touchend", function (e) {
        e.preventDefault();
        $(this).children("i").toggleClass('fa-bars').toggleClass('fa-xmark');
        $(".sidebar-navigation .navigation").slideToggle().toggleClass("open");
        return false;
    });

    $(window).on("resize", function () {
        let $nav = $(".sidebar-navigation .navigation");
        if($(window).width() > 992) {
            $nav.css("display", "block");
        }
    });

    $(".sidebar-navigation .navigation .menu .menu-item-has-children").each(function () {
        $(this).children("a").after('<div class="toggle"><i class="fa-light fa-chevron-down"></i></div>');
    });

    $(".sidebar-navigation .navigation .menu .menu-item-has-children .toggle").on("mousedown", function () {
        $(this).next(".sub-menu").slideToggle();
    });

    $(document).ready(function () {
        if($(".sidebar-navigation ul li.current_page_item.menu-item-has-children")) {
            $(".sidebar-navigation ul li.current_page_item.menu-item-has-children").find(".sub-menu").slideDown();
        }
        if($(".sidebar-navigation ul li.current_page_ancestor.menu-item-has-children")) {
            $(".sidebar-navigation ul li.current_page_ancestor.menu-item-has-children").find(".sub-menu").slideDown();
        }
    });

})( jQuery );